import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import 'typeface-roboto';
import "../styles/timeline.css"
   
function Timeline() {
  return (
    <div className="timeline">
      <h2 style={{ fontSize: '1.5em', fontFamily: "Roboto" }}>My Career Development</h2>
      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: '#0099FF', color: 'black' }}
          contentArrowStyle={{ borderRight: '7px solid  #0099FF' }}
          date="January 2024 - December 2024"
          iconStyle={{ background: '#0099FF', color: '#fff' }}
          //icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">Artificial Intelligence Projects</h3>
          <h4 className="vertical-timeline-element-subtitle">San Jose, CA</h4>
          <a href="/ai-projects" style={{ color: 'yellow' }} rel="noreferrer"> Link to AI Projects </a>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: '#FF3366', color: 'black' }}
          contentArrowStyle={{ borderRight: '7px solid  #FF3366' }}
          date="July 2023 - Nov 2023"
          iconStyle={{ background: '#FF3366', color: '#fff' }}
          //icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">Software Engineer</h3>
          <h4 className="vertical-timeline-element-subtitle">San Francisco, CA</h4>
          <p>
            Implemented web application that integrated LLMs, deployed to AWS, and set up CI/CD.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: '#C3B1E1', color: 'black' }}
          contentArrowStyle={{ borderRight: '7px solid  #C3B1E1' }}
          date="March 2022 - November 2022"
          iconStyle={{ background: '#C3B1E1', color: '#fff' }}
          //icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">Software Engineer</h3>
          <h4 className="vertical-timeline-element-subtitle">San Ramon, CA</h4>
          <p>
            Medical devices and AI. Integrated new ML models into system. Led and implemented MLOps. Python, Flask.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: '#FDFD96', color: 'black' }}
          contentArrowStyle={{ borderRight: '7px solid  #FDFD96' }}
          date="March 2021 - March 2022"
          iconStyle={{ background: '#FDFD96', color: '#fff' }}
          //icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title" style={{color: "green"}}>Software Engineer</h3>
          <h4 className="vertical-timeline-element-subtitle" style={{color: "green"}}>San Francisco, CA</h4>
          <p style={{color: "green"}}>
            Consumed APIs. Developed mobile app and web app. Python, React Native, Angular.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: '#0099FF', color: 'black' }}
          contentArrowStyle={{ borderRight: '7px solid  #0099FF' }}
          date="July 2020 - November 2020"
          iconStyle={{ background: '#0099FF', color: '#fff' }}
          //icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">Full Stack Engineer Intern</h3>
          <h4 className="vertical-timeline-element-subtitle">Berkeley, CA</h4>
          <p>
            Developed booking form with complex backend retrieving insurance information. Increased access 
            to mental healthcare. PHP, JavaScript, React, MySQL. 
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: '#FF3366', color: 'black' }}
          contentArrowStyle={{ borderRight: '7px solid  #FF3366' }}
          date="February 2019 - May 2020"
          iconStyle={{ background: '#FF3366', color: '#fff' }}
          //icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">Product Manager</h3>
          <h4 className="vertical-timeline-element-subtitle">San Francisco, CA</h4>
          <p>
            Led the development of a new educational site for homeowners. Post-launching user traffic increased by 10X.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          contentStyle={{ background: '#C3B1E1', color: 'black' }}
          contentArrowStyle={{ borderRight: '7px solid  #C3B1E1' }}
          date="Fall 2018"
          iconStyle={{ background: '#C3B1E1', color: '#fff' }}
          //icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">Web Mining & Recommender Systems Course at UCSD</h3>
          <h4 className="vertical-timeline-element-subtitle">San Diego, CA</h4>
          <p>
            Developed recommender system for Goodreads users. Machine learning models. Python.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: '#FDFD96', color: 'black' }}
          contentArrowStyle={{ borderRight: '7px solid  #FDFD96' }}
          date="April 2018 - December 2018"
          iconStyle={{ background: '#FDFD96', color: '#fff' }}
          //icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title" style={{color: "green"}}>iOS Developer</h3>
          <h4 className="vertical-timeline-element-subtitle" style={{color: "green"}}>San Diego, CA</h4>
          <p style={{color: "green"}}>
            Developed iOS version of guided journaling app. Launched into app store. Mentored 3 junior engineers.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          contentStyle={{ background: '#0099FF', color: 'black' }}
          contentArrowStyle={{ borderRight: '7px solid  #0099FF' }}
          date="June 2014 - February 2015"
          iconStyle={{ background: '#0099FF', color: '#fff' }}
          //icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">UCSD Women In Computing Board - Technical Skills Co-Chair</h3>
          <h4 className="vertical-timeline-element-subtitle">San Diego, CA</h4>
          <p>
            Planned and executed campus-wide hackathon to spur new ideas for improving people's lives.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          contentStyle={{ background: '#FF3366', color: 'black' }}
          contentArrowStyle={{ borderRight: '7px solid  #FF3366' }}
          date="2009 - 2012"
          iconStyle={{ background: '#FF3366', color: '#fff' }}
          //icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">Member of Gunn High School Robotics Team</h3>
          <h4 className="vertical-timeline-element-subtitle">Palo Alto, CA</h4>
          <p>
            Build team. Developed mechanical prototypes. Started to develop engineering mindset.
          </p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
}
export default Timeline;
